module.exports = __webpack_public_path__ + "NG.png?c17ec02cdcf4601fc63f5e0c8cb259ec";